/**
 * <s-scheme-toggle> — appearance choice: Sistema / Claro / Escuro.
 * Each child button carries data-scheme-value="system|light|dark". Claro and Escuro set
 * html[data-scheme] and are saved; Sistema removes both so the device setting decides.
 * Several instances (header card, menu drawer) stay in sync through a document event.
 */
const STORAGE_KEY = 'saga128-scheme';

function currentChoice() {
  const value = document.documentElement.getAttribute('data-scheme');
  return value === 'light' || value === 'dark' ? value : 'system';
}

class SSchemeToggle extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-scheme-value]'));

    this.handleClick = (event) => {
      const button = event.target.closest('[data-scheme-value]');
      if (!button || !this.contains(button)) return;
      const value = button.getAttribute('data-scheme-value');
      try {
        if (value === 'system') localStorage.removeItem(STORAGE_KEY);
        else localStorage.setItem(STORAGE_KEY, value);
      } catch (error) {
        /* Storage blocked: the choice still applies for this page view. */
      }
      if (value === 'system') document.documentElement.removeAttribute('data-scheme');
      else document.documentElement.setAttribute('data-scheme', value);
      document.dispatchEvent(new CustomEvent('scheme:change'));
    };
    this.handleChange = () => this.sync();

    this.addEventListener('click', this.handleClick);
    document.addEventListener('scheme:change', this.handleChange);
    this.sync();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    document.removeEventListener('scheme:change', this.handleChange);
  }

  sync() {
    const choice = currentChoice();
    this.buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-scheme-value') === choice));
    });
  }
}

if (!customElements.get('s-scheme-toggle')) {
  customElements.define('s-scheme-toggle', SSchemeToggle);
}
